var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguage = function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "language_svg__a",
    width: 25,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.61 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#language_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    d: "M12.61 22a10.14 10.14 0 0 1-9.21-6.13A9.7 9.7 0 0 1 2.6 12c0-1.38.26-2.68.79-3.89A10.18 10.18 0 0 1 8.74 2.8 9.7 9.7 0 0 1 12.6 2c1.38 0 2.68.26 3.89.79a10.18 10.18 0 0 1 5.32 5.32c.53 1.21.79 2.5.79 3.89a10.14 10.14 0 0 1-6.11 9.21c-1.21.53-2.5.79-3.89.79Zm0-2.05a12.7 12.7 0 0 0 1.9-3.95h-3.8a11.8 11.8 0 0 0 1.9 3.95m-2.6-.4A13.9 13.9 0 0 1 8.66 16H5.71a8.3 8.3 0 0 0 1.81 2.18 7.2 7.2 0 0 0 2.49 1.37m5.2 0a7.2 7.2 0 0 0 2.49-1.38A8.3 8.3 0 0 0 19.5 16h-2.95a14.7 14.7 0 0 1-1.35 3.55ZM4.86 14h3.4a13.8 13.8 0 0 1 0-4h-3.4a8.6 8.6 0 0 0-.19 3.01c.04.33.1.66.19.99m5.4 0h4.7a13.8 13.8 0 0 0 0-4h-4.7a13.8 13.8 0 0 0 0 4m6.7 0h3.4a8.6 8.6 0 0 0 .19-3.01c-.04-.33-.1-.66-.19-.99h-3.4a13.8 13.8 0 0 1 0 4m-.4-6h2.95a8.3 8.3 0 0 0-1.81-2.17 7.2 7.2 0 0 0-2.49-1.38A13.9 13.9 0 0 1 16.56 8m-5.85 0h3.8a11.8 11.8 0 0 0-1.9-3.95A12.7 12.7 0 0 0 10.71 8m-5 0h2.95a14.7 14.7 0 0 1 1.35-3.55 7.2 7.2 0 0 0-2.49 1.38A8.3 8.3 0 0 0 5.71 8"
  }))));
};
export default SvgLanguage;